// extracted by mini-css-extract-plugin
export default {"button":"chatbot-button_button__H0mby"};